export default __webpack_public_path__ + "static/media/stephanie_tommy-184_tn.ef938120.jpg";